import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";
import { dbh_custom_validation } from '../ClientValidation/dbh_custom_validation';
import { dbh_suchergebnis } from "../Controls/dbh_suchergebnis";

if (dbh_helper.getUrlArea() == "abrechnungen") {
    $(document).ready(function () {
        let id = dbh_helper.getUrlParameter("id");

        initSortableTable();

        $("#typescriptAbrechnungProxy").on("click", function (event, actionName, controllerName, parameter, htmlId, doOnSuccess, type) {

            if (type === "post") {
                sendPostRequest(actionName, controllerName, parameter, htmlId, doOnSuccess);
            } else {
                sendGetRequest(actionName, controllerName, parameter, htmlId, doOnSuccess);
            }
        })

        $(".dbh_action.zahlungseingang").on("click", function () {
            sendGetRequest("GetZahlungseingangPopupView", "Abrechnungen/Rechnungen", [["id", id]], "#zahlungseingang-placeholder", function () {
                $("#ZahlungseingangViewComponentPopup").fadeIn();
                window.setTimeout(function () {
                    $('#zahlungBuchenForm #BezahltAm').focus();
                }, 1000);

                $('#zahlungBuchenForm').off('keypress');
                $('#zahlungBuchenForm').on('keypress', function (e) {
                    if (e.which == 13) {
                        $('#zahlungBuchenForm #BezahlterBetragString').first().focus();
                        // Fokus auf Betrag setzen, damit die Datumseingabe korrekt in das DE Format überführt wird
                        window.setTimeout(function () {
                            $("#zahlungBuchenBtn").get(0).click();
                        }, 200);
                    }
                });

                $("#zahlungBuchenBtn").on("click", function () {
                    const bezahltAm = $("#BezahltAm").val();
                    let dbhCustomValidation = new dbh_custom_validation();
                    if (!dbhCustomValidation.validateForm("#zahlungBuchenForm")) {
                        return;
                    }

                    const model = [
                        ["pk_rechnungen", id],
                        ["bezahltAm", bezahltAm],
                        ["bezahlterBetrag", +$("#BezahlterBetragString").val().toString().replace(",", ".")]
                    ];

                    sendPostRequest("ZahlungseingangBuchen", "Abrechnungen/Rechnungen", model, null, function () {
                        $("#ZahlungseingangViewComponentPopup").fadeOut();

                        const $sumLabel = $("#sumLabel");
                        const $paidSumElement = $("#paidSumLabel");
                        const $differenceLabel = $("#differenceLabel");
                        const $paidDateLabel = $("#paidDateLabel");

                        const summeVal = getNumberFromString($sumLabel.text().replace(".", "").replace(",", "."));
                        const oldBetrag = getNumberFromString($paidSumElement.text().replace(".", "").replace(",", "."));
                        const paidBetrag = +$("#BezahlterBetragString").val().toString().replace(".", "").replace(",", ".");

                        const newBetrag = oldBetrag + paidBetrag;
                        const newDifference = summeVal - newBetrag;

                        $paidSumElement.text(newBetrag.toFixed(2).replace(".", ","));
                        $differenceLabel.text(newDifference.toFixed(2).replace(".", ","));
                        $paidDateLabel.text(bezahltAm.toString());
                    });
                });
            });
        });

        $(".rdbAbrechnung").on("change", function () {
            const psgSelected = $(this).attr("id") === 'rdbPSG';

            if (psgSelected) {
                $(".psgRow").removeClass("inactive");
                $(".whngRow").addClass("inactive");
                $("#PsgSelected").val("True");
            }
            else {
                $(".psgRow").addClass("inactive");
                $(".whngRow").removeClass("inactive");
                $("#PsgSelected").val("False");
            }
        })

        $(".dbh_action.stornieren").on("click", function () {
            const parameter = [["id", id]];
            const isGutschriften = window.location.pathname.toLowerCase().includes("gutschriften");
            const controllerName = isGutschriften ? "Abrechnungen/Gutschriften" : "Abrechnungen/Rechnungen";
            const popupId = isGutschriften ? "GutschriftStornierenViewComponentPopup" : "RechnungStornierenViewComponentPopup";
            sendGetRequest("Stornieren", controllerName, parameter, "#storno-placeholder", function () {
                $(`#${popupId}`).show();
            });
        })

        $(".ddlAmt").on("change", function () {
            const selectedId: string = $(this).find(":selected").val().toString();

            if (selectedId.length > 0) {
                new dbh_ajax().sendGetRequest({
                    actionName: "AmtSelectedIndexChanged",
                    controllerName: "Abrechnungen/Rechnungen",
                    parameter: [["id", selectedId]],
                    callbackSuccess: (ajaxResult: any) => {
                        const $adresse = $("textarea[name='Adresse']");
                        const plainText = $("<div>").html(ajaxResult.responseText).text().trim();
                        $adresse.val(plainText);
                    },
                    callbackError: (ajaxResult: object) => {
                    }
                });
            }
        })

        // Kendo ComboBox Change-Event für FK_Amt nach Aktivierung des Edit-Modus binden
        dbh_helper.OnEditModeActivated = () => {
            const kendoComboBox = $("#FK_Amt").data("kendoComboBox");
            if (!kendoComboBox) return;
            kendoComboBox.unbind("change");
            kendoComboBox.bind("change", function () {
                const selectedId: string = this.value();
                if (selectedId && selectedId.length > 0) {
                    new dbh_ajax().sendGetRequest({
                        actionName: "AmtSelectedIndexChanged",
                        controllerName: "Abrechnungen/Rechnungen",
                        parameter: [["id", selectedId]],
                        callbackSuccess: (ajaxResult: any) => {
                            const $adresse = $("textarea[name='Adresse']");
                            const plainText = $("<div>").html(ajaxResult.responseText).text().trim();
                            $adresse.val(plainText);
                        },
                        callbackError: (ajaxResult: object) => { }
                    });
                }
            });
        };

        if ($(".nrMonth").length > 0 && $(".nrMonth").val().toString().trim().length > 0 &&
            $(".nrYear").length > 0 && $(".nrYear").val().toString().trim().length > 0) {
            setRNNumber($(".nrMonth").val(), $(".nrYear").val());
        }

        $(".nrMonth").on("change", function () {
            setRNNumber($(this).val(), $(".nrYear").val());
        })
        $(".nrYear").on("change", function () {
            setRNNumber($(".nrMonth").val(), $(this).val());
        })

        $("#typescriptExportLaeufeTableProxy").on("click", function (event, type, id) {
            let actionName = '';
            let popupId = '';

            switch (type) {
                case 'exportieren':
                    actionName = "ExportLaufFromTable";
                    window.open("/Abrechnungen/Rechnungen/" + actionName + "?id=" + id, '_blank').focus();
                    return;
                    //popupId = "EditBetreuerInViewComponentPopup";
                    break;
                case 'abschließen':
                    actionName = "AbschlussLaufFromTable";
                    popupId = "DatevAbgeschlossenViewComponentPopup";

                    new dbh_ajax().sendGetRequest({
                        actionName: actionName,
                        controllerName: "Abrechnungen/Rechnungen",
                        parameter: [["id", id]],
                        callbackSuccess: (ajaxResult: any) => {
                            $(`#abgeschlossen-placeholder`).html(ajaxResult.responseText);
                            $(`#${popupId}`).fadeIn("fast");
                        },
                        callbackError: (ajaxResult: object) => {

                        }
                    });
                    break;
                default:
                    break;
            }

            console.log("type: ", type);
            console.log("id: ", id);
        })

        $("#typescriptOffeneLaeufeTableProxy").on("click", function (event, type, id) {
            let actionName = '';
            let popupId = '';


            switch (type) {
                case 'exportieren':
                    actionName = "ExportOffenenLaufFromTable";
                    window.open("/Abrechnungen/Rechnungen/" + actionName + "?laeufeKeys=" + id, '_blank').focus();
                    return;
                    //popupId = "EditBetreuerInViewComponentPopup";
                    break;
                default:
                    break;
            }
        })


    });
    $('#dbh_rechnungenDetails').ready(function () {
        if ($('#dbh_rechnungenDetails').length > 0) {
            /* 
            *  Die Add-Btns sind aktuell nur eingebunden, wenn der entsprechende Datensatz nicht exportiert wurde 
            *  (was für add/edit passt, da beides nur stattfinden darf wenn Datensatz nicht exportiert ist)
            */
            initTableFunctionality();

            if ($('#addRechnungspositionBtn').length > 0) {
                $('#addRechnungspositionBtn').on("click", function () {
                    GetPositionPopup("Rechnungen", "RechnungspositionenViewComponentPopup");
                });
            }
            if ($('#addGutschriftenpositionBtn').length > 0) {
                $('#addGutschriftenpositionBtn').on("click", function () {
                    GetPositionPopup("Gutschriften", "GutschriftenpositionenViewComponentPopup");
                });
            }

            dbh_helper.OnSetDefaultFormValues = () => {
                doOnRebind();
            };
        }
    })
}

function BindGetEditPositionPopup(controller: string, tableContainer: string, popupId: string) {
    const $rows = $(`#${tableContainer} *[data-rowid]`);
    $rows.off("click");

    const clickElements = [];

    for (let i = 0; i < $rows.length; i++) {
        const $curRow = $($rows[i]);
        const rowId = $curRow.data("rowid");
        if ($rows[i].classList.contains("dbhSuchergebnisKachel")) {
            clickElements.push([$rows[i], rowId]);
        } else {
            const $cells = $curRow.children("td");
            $cells.off("click");

            for (let i = 0; i < $cells.length; i++) {
                if ($cells[i].innerHTML.indexOf("checkbox") < 0) {
                    clickElements.push([$cells[i], rowId]);
                }
            }
        }
    }

    for (let i = 0; i < clickElements.length; i++) {
        $(clickElements[i][0]).on("click", function (e) {
            GetPositionPopup(controller, popupId, clickElements[i][1]);
        });
    }
}

const GetPositionPopup = (controller: string, popupId: string, id: string = "") => {
    let dbhCustomValidation = new dbh_custom_validation();
    if (!dbhCustomValidation.validateForm("#rechnungsPositionPopupForm")) {
        return;
    }

    const showPopup = () => {
        //@ts-ignore
        window.showPopup(popupId);
    };

    sendGetRequest('GetPositionPopupView', `Abrechnungen/${controller}`, [["positionId", id]], "#abrechnung-placeholder", showPopup);
    //@ts-ignore
    window.hidePopup(popupId);
}

const isRechnungSeite = () => {
    return document.getElementById("GutschriftenpositionenTabelleMitSuche") === null;
}

const initTableFunctionality = () => {
    const $showDeletedPositionenBtn = $("#showDeletedPositionenBtn");
    const $hideDeletedPositionenBtn = $("#hideDeletedPositionenBtn");
    dbh_helper.SetTableBtnClick($showDeletedPositionenBtn, true, showDeletedPositionen);
    dbh_helper.SetTableBtnClick($hideDeletedPositionenBtn, true, hideDeletedPositionen);

    $(".table-checkbox").off("change");
    $(".table-checkbox").on("change", function () {
        const $chkbox = $(this);
        const $table = $chkbox.parents("table");
        const $allCheckboxes = $table.find(".table-checkbox");

        let activeCheckboxesCount = 0;

        for (let i = 0; i < $allCheckboxes.length; i++) {
            if ($($allCheckboxes[i]).prop("checked") === true) {
                activeCheckboxesCount++;
            }
        }

        const $allCheckbox = $table.find('.table-allCheckbox');

        if ($allCheckbox.prop("checked")) {
            if (activeCheckboxesCount !== $allCheckboxes.length) {
                $allCheckbox.prop("checked", "");
            }
        } else {
            if (activeCheckboxesCount === $allCheckboxes.length) {
                $allCheckbox.prop("checked", "checked");
            }
        }

        const $deleteBtn = $("#positionDeleteBtn");
        const $uniteBtn = $("#positionUniteBtn");
        dbh_helper.SetTableBtnClick($deleteBtn, (activeCheckboxesCount > 0), deleteFunction);
        dbh_helper.SetTableBtnClick($uniteBtn, (activeCheckboxesCount > 1), uniteFunction);
    })

    $('.table-allCheckbox').off("change");
    $('.table-allCheckbox').on("change", function () {
        const $chkbox = $(this);
        const checked = $chkbox.prop("checked");

        const $table = $chkbox.parents("table");
        const $allCheckboxes = $table.find(".table-checkbox");

        for (let i = 0; i < $allCheckboxes.length; i++) {
            const $checkbox = $($allCheckboxes[i]);
            $checkbox.prop("checked", checked ? "checked" : "");
        }

        let activeCheckboxesCount = 0;

        if (checked) {
            activeCheckboxesCount = $allCheckboxes.length;
        }

        const $deleteBtn = $("#positionDeleteBtn");
        const $uniteBtn = $("#positionUniteBtn");

        dbh_helper.SetTableBtnClick($deleteBtn, (activeCheckboxesCount > 0), deleteFunction);
        dbh_helper.SetTableBtnClick($uniteBtn, (activeCheckboxesCount > 1), uniteFunction);
    });

    $(".dbhTableReaktivierenRechnungspositionBtn").off("click");
    $(".dbhTableReaktivierenRechnungspositionBtn").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let form = dbh_helper.findNearestForm(this);
        new dbh_ajax().sendPostRequest({
            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val().toString() : '',
            actionName: "PositionReaktivieren",
            controllerName: "Abrechnungen/Rechnungen",
            parameter: { key: $(this).data("id") },
            loadingTarget: null,
            callbackSuccess: (ajaxResult: any) => {
                new dbh_suchergebnis().defaultReloadSearchResult($('#position-tabellen-container .dbhSuchergebnis').first().get(0));

                // Umschalt-Buttons ausblenden, wenn keine Position mehr als gelöscht markiert ist
                if ($(".dbhTableReaktivierenRechnungspositionBtn").length == 0) {
                    $("#hideDeletedPositionenBtn").addClass('hidden');
                    $("#showDeletedPositionen").addClass('hidden');
                }
            },
            callbackError: (ajaxResult: object) => {
            }
        });
    });

    $(".dbhTableReaktivierenGutschriftenpositionBtn").off("click");
    $(".dbhTableReaktivierenGutschriftenpositionBtn").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let form = dbh_helper.findNearestForm(this);
        new dbh_ajax().sendPostRequest({
            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val().toString() : '',
            actionName: "PositionReaktivieren",
            controllerName: "Abrechnungen/Gutschriften",
            parameter: { key: $(this).data("id") },
            loadingTarget: null,
            callbackSuccess: (ajaxResult: any) => {
                new dbh_suchergebnis().defaultReloadSearchResult($('#position-tabellen-container .dbhSuchergebnis').first().get(0));

                // Umschalt-Buttons ausblenden, wenn keine Position mehr als gelöscht markiert ist
                if ($(".dbhTableReaktivierenGutschriftenpositionBtn").length == 0) {
                    $("#hideDeletedPositionenBtn").addClass('hidden');
                    $("#showDeletedPositionen").addClass('hidden');
                }
            },
            callbackError: (ajaxResult: object) => {
            }
        });
    });
}

const showDeletedPositionen = () => {
    $("#showDeletedPositionenBtn").addClass('hidden');
    $("#hideDeletedPositionenBtn").removeClass('hidden');
    changeRowEntryAfterSave(true);
}

const hideDeletedPositionen = () => {
    $("#hideDeletedPositionenBtn").addClass('hidden');
    $("#showDeletedPositionenBtn").removeClass('hidden');
    changeRowEntryAfterSave(false);
}

const deleteFunction = () => {
    const isRechnung = isRechnungSeite();
    const $container = isRechnung ? $("#RechnungspositionenTabelleMitSuche") : $("#GutschriftenpositionenTabelleMitSuche");
    const $chkboxes = $container.find(".table-checkbox");
    const keys = getTableCheckboxKeys($chkboxes);

    /*ajax-Call mit den Keys als Parameter*/
    const parameter = [["listOfKeys", keys.join(",")]];
    sendGetRequest("Delete", isRechnung ? "Abrechnungen/Rechnungen" : "Abrechnungen/Gutschriften", parameter, "", function () {
        // reload Tabelle                                        
        new dbh_suchergebnis().defaultReloadSearchResult($('#position-tabellen-container .dbhSuchergebnis').first().get(0));
        changeRowEntryAfterSave();
    });

    // Button einblenden, wenn vorher noch kein Element gelöscht war
    if ($("#hideDeletedPositionenBtn").hasClass('hidden') && $("#showDeletedPositionenBtn").hasClass('hidden')) {
        $("#showDeletedPositionenBtn").removeClass('hidden');
    }
}

const uniteFunction = () => {
    const isRechnung = isRechnungSeite();
    const $container = isRechnung ? $("#RechnungspositionenTabelleMitSuche") : $("#GutschriftenpositionenTabelleMitSuche");
    const $chkboxes = $container.find(".table-checkbox");
    const keys = getTableCheckboxKeys($chkboxes);

    /*ajax-Call mit den Keys als Parameter*/
    const parameter = [["listOfKeys", keys.join(",")]];
    sendGetRequest("Unite", isRechnung ? "Abrechnungen/Rechnungen" : "Abrechnungen/Gutschriften", parameter, "", changeRowEntryAfterSave);
}

const getTableCheckboxKeys = ($checkboxList) => {
    const keys = [];

    for (let i = 0; i < $checkboxList.length; i++) {
        const $curCheckbox = $($checkboxList[i]);
        if ($curCheckbox.prop("checked") === true) {
            keys.push($curCheckbox.data().key.toString());
        }
    }

    return keys;
}

const initSortableTable = () => {
const tables = $(".dbhSuchergebnisKlein");
for (let i = 0; i < tables.length; i++) {
    const $table = $(tables[i]);
    const $container = $table.closest("[data-disable-sort]");
    if ($container.length > 0 && $container.data("disable-sort") === true) {
        continue;
    }
    if ($table.find("tr[data-sortkey").length > 0) {
            (<any>$(tables).find("tbody")).sortable({
                update: function (event, ui) {
                    const isRechnung = isRechnungSeite();
                    const tabelleMitSuche = isRechnung ? $("#RechnungspositionenTabelleMitSuche") : $("#GutschriftenpositionenTabelleMitSuche");

                    const controllerName = "Abrechnungen/" + tabelleMitSuche.data().controller;
                    const $sortedItems = $(".dbhSuchergebnisKlein tbody tr");
                    const sortedKeys = [];
                    for (let i = 0; i < $sortedItems.length; i++) {
                        sortedKeys.push($($sortedItems[i]).data().sortkey);
                    }

                    const parameter = [["listOfKeys", sortedKeys.join(",")]];
                    sendGetRequest("Sort", controllerName, parameter, "");
                }
            });
        }
    }
}

const getNumberFromString = (val): number => {
    let numb = +val;
    if (isNaN(numb)) {
        numb = 0;
    }
    return numb;
}

function changeSumLabelValue() {
    const $sumLabel = $("#sumLabel");
    const $positionTabellenContainer = $("#position-tabellen-container");
    const $tr = $positionTabellenContainer.find("tr");
    let sum = 0;

    for (let i = 0; i < $tr.length; i++) {
        const $tdElements = $($tr[i]).find("td");
        if ($tdElements.length > 0) {
            const $tdBetragElement = $($tdElements[2]);
            const betragValue = $tdBetragElement.text().replace(",", ".");

            sum += +betragValue;
        }
    }

    $sumLabel.html(sum.toFixed(2).replace(".", ","));
}

const setRNNumber = (month, year) => {
    const $nrElement = $(".nrNr");

    if (month.length > 0 && year.length > 0) {
        new dbh_ajax().sendGetRequest({
            actionName: "GetRENummer",
            controllerName: "Abrechnungen/Rechnungen",
            parameter: [["monat", month], ["jahr", year]],
            callbackSuccess: (ajaxResult: any) => {
                $nrElement.text(ajaxResult.responseText.replaceAll("\"", ""));
                $nrElement.removeClass("showRed");
            },
            callbackError: (ajaxResult: object) => {
                $nrElement.text("Monat und Jahr benötigt!")
                $nrElement.addClass("showRed");
            }
        });
    } else {
        $nrElement.text("Monat und Jahr benötigt!")
        $nrElement.addClass("showRed");
    }
}

const doOnRebind = () => {
    if (isRechnungSeite()) {
        BindGetEditPositionPopup("Rechnungen",
            "RechnungspositionenTabelleMitSuche",
            "RechnungspositionenViewComponentPopup");

        $("#rPosSave").on("click", function () {
            savePositionChanges("#rPosSave");
        });

        $("#rPosCancel").on("click", function () {
            cancelPositionEdit("RechnungspositionenViewComponentPopup");
        });
    }
    else {
        BindGetEditPositionPopup("Gutschriften",
            "GutschriftenpositionenTabelleMitSuche",
            "GutschriftenpositionenViewComponentPopup");

        $("#gPosSave").on("click", function () {
            savePositionChanges("#gPosSave");
        });

        $("#gPosCancel").on("click", function () {
            cancelPositionEdit("GutschriftenpositionenViewComponentPopup");
        });
    }

    initTableFunctionality();
    initSortableTable();

    $("#posNew").on("click", function () {
        addNewPosition(isRechnungSeite());
    });
}

const savePositionChanges = (id) => {
    let model = [
        ["key", $(id).data("pk")],
        //@ts-ignore
        ["position", document.getElementById("Position").value],
        //@ts-ignore
        ["betrag", document.getElementById("BetragString").value]];

    const isRechnung = isRechnungSeite();

    if (isRechnung) {
        //@ts-ignore
        model.push(["konto", document.getElementById("Konto").value]);
    }

    let dbhCustomValidation = new dbh_custom_validation();
    if (!dbhCustomValidation.validateForm("#rechnungsPositionPopupForm")) {
        return;
    }

    sendGetRequest("SavePositionChange", `Abrechnungen/${isRechnung ? "Rechnungen" : "Gutschriften"}`, model, null, changeRowEntryAfterSave);
    //@ts-ignore
    window.hidePopup(isRechnung ? "RechnungspositionenViewComponentPopup" : "GutschriftenpositionenViewComponentPopup");
};

const addNewPosition = (isRechnung) => {
    let model = [];

    if (isRechnung) {
        //@ts-ignore
        model.push(["rechnung", document.getElementById("PK_Rechnungen").value])
        //@ts-ignore
        model.push(["konto", document.getElementById("Konto").value]);
    } else {
        //@ts-ignore
        model.push(["gutschrift", document.getElementById("PK_Gutschriften").value]);
    }
    //@ts-ignore
    model.push(["position", document.getElementById("Position").value]);
    //@ts-ignore
    model.push(["betrag", document.getElementById("BetragString").value]);

    const controller = isRechnung ? "Rechnungen" : "Gutschriften";
    sendGetRequest("AddPosition", `Abrechnungen/${controller}`, model, null, changeRowEntryAfterSave);

    //@ts-ignore
    window.hidePopup(isRechnung ? "RechnungspositionenViewComponentPopup" : "GutschriftenpositionenViewComponentPopup");
};

const changeRowEntryAfterSave = (showDeletedPositionen: boolean = false) => {
    const type = isRechnungSeite() ? "Rechnungen" : "Gutschriften";
    //@ts-ignore
    let model = `FK_${type}=${document.getElementById(`PK_${type}`).value}&showDeletedPositionen=${showDeletedPositionen}`;

    sendPostRequest(
        isRechnungSeite() ? "GetRechnungspositonen" : "GetGutschriftenpositonen",
        `Abrechnungen/${type}`, model, "#position-tabellen-container",
        handleViewAfterPositionChange);
};

const handleViewAfterPositionChange = () => {
    initTableFunctionality();
    initSortableTable();
    changeSumLabelValue();
}

const cancelPositionEdit = (popupId) => {
    //@ts-ignore
    window.hidePopup(popupId);
}

const sendGetRequest = (actionName, controllerName, parameter, htmlId, doOnSuccess = null) => {
    return new dbh_ajax().sendGetRequest({
        actionName: actionName,
        controllerName: controllerName,
        parameter: parameter,
        callbackSuccess: (ajaxResult: any) => {
            if (htmlId !== undefined && htmlId !== null) {
                $(`${htmlId}`).html(ajaxResult.responseText);
            }
            if (doOnSuccess !== undefined && doOnSuccess !== null) {
                doOnSuccess();
            }
        },
        callbackError: (ajaxResult: object) => {

        }
    });
}

const sendPostRequest = (actionName, controllerName, parameter, htmlId, doOnSuccess = null) => {

    return new dbh_ajax().sendPostRequest({
        csrfToken: /*form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val().toString() :*/ '',
        actionName: actionName,
        controllerName: controllerName,
        parameter: parameter,
        loadingTarget: null,
        callbackSuccess: (ajaxResult: any) => {

            if (htmlId !== undefined && htmlId !== null) {
                $(`${htmlId}`).html(ajaxResult);
            }
            if (doOnSuccess !== undefined && doOnSuccess !== null) {
                doOnSuccess();
            }
        },
        callbackError: (ajaxResult: object) => {

        }
    });
}